<script lang="ts">
    import cn from 'classnames';

    import LL from '@i18n/i18n-svelte';
    import { Font, FontTypes } from '@uikit/font';

    import { SalePropType } from './index';

    import s from './sale.module.css';

    export let value = 0;
    export let type: SalePropType = SalePropType.Filled;
    export let classes = '';
    export let discountLabel = '';

    $: formattedLabel = value ? `${value}% ${$LL.subscription.common.OFF()}` : `🔥 ${$LL.limitedOffer()}`;
</script>

<div class={cn(s.sale, classes, {
    [s.round]: type === SalePropType.Round,
    [s.outlined]: type === SalePropType.Outlined,
})}>
    <Font className={type === SalePropType.Outlined ? s.gold : s.black}
          isBold
          color={null}
          attrs={{ 'data-testid': 'saleBadge' }}
          type={type === SalePropType.Round ? FontTypes.Type.tiny : FontTypes.Type.caption}
          tagName={FontTypes.TagName.span}
    >
        {formattedLabel}
    </Font>
    {#if discountLabel}
        <Font
            isBold
            type={type === SalePropType.Round ? FontTypes.Type.tiny : FontTypes.Type.caption}
            tagName={FontTypes.TagName.span}
        >{discountLabel}</Font>
    {/if}
</div>

